import Immutable from 'immutable';
import { DisciplineDesignator, DisciplineId } from 'records/Discipline';

export interface RawUpdateSheetDiscipline {
  id?: DisciplineId;
  designator: DisciplineDesignator;
  description: string;
}

export interface UpdateSheetDisciplineData {
  id?: DisciplineId;
  designator: DisciplineDesignator;
  description: string;
}

const defaultValues: UpdateSheetDisciplineData = {
  id: '',
  designator: 'unassigned',
  description: 'Unassigned',
};

export const UpdateSheetDisciplineFactory = Immutable.Record(
  defaultValues,
  'Discipline'
);

export class UpdateSheetDiscipline extends UpdateSheetDisciplineFactory {
  static deserialize(
    rawDiscipline: RawUpdateSheetDiscipline
  ): UpdateSheetDiscipline {
    return new UpdateSheetDiscipline(rawDiscipline);
  }

  serialize(): RawUpdateSheetDiscipline {
    return this.toJS();
  }
}
